<template>
  <div>
    <!-- plan -->
    <div
      :class="['bg-top-center bg-no-repeat bg-cover relative pt-[80px] pb-[10px] bg-[#e9ecec]', {'summer-section': promotionEnabled}]">
      <div
        class="max-w-[1210px] m-auto flex flex-col relative bg-no-repeat bg-center text-left items-center justify-center mb-[16px]">
        <h1 class="text-[44px] leading-[66px] text-[#12182C] text-center flex items-center">{{ plan }}
        </h1>
        <!-- <p class="text-[16px] leading-[19px] text-[#12182C] mt-[10px] mb-[30px]">{{ introduction }}</p> -->
      </div>

      <div class="mb-[43px] relative">
        <!-- category -->
        <!-- <div class="w-full mb-[32px] flex justify-center">
          <div
            class="mx-auto h-[48px] w-max max-w-[95%] min-h-[48px] flex flex-row items-center justify-center border-[#FFD9AE] rounded-[10px] border-2 overflow-hidden">
            <a v-for="category in categories" :href="category.url" @click.prevent="navigateToPlan(category)"
              :class="{ 'text-[#EE3237] bg-[#FFD9AE]': currentCategory.name === category.name }"
              class="relative h-full flex flex-col items-center justify-around w-[154px] text-[16px] text-[#223265] text-center"
              target="_self">
              <div class="h-full flex items-center justify-center font-bold uppercase">
                <div>{{ category.name }}</div>
              </div>
            </a>
          </div>
        </div> -->

        <!--spu-->
        <!-- <div class="w-full flex justify-center">
          <div
            class="mx-auto h-[69px] w-max max-w-[95%] min-h-[69px] flex flex-row items-center justify-center border-[#FFD9AE] rounded-[8px] border bg-[#FFFAF7] mb-[26px]">
            <a v-for="spu in spus" :href="spu.url" @click.prevent="navigateToPlan(spu, true)"
              class="relative h-full flex flex-col items-center justify-center min-w-[150px] px-[20px] text-[16px] color-[#223265] text-center"
              target="_self">
              <div
                :class="['leading-none flex items-center justify-center', 
                { 'py-[15px] px-[10px] text-[#EE3237] bg-[#FFD9AE] shadow-md rounded-[4px] border-[#EE3237] relative': currentSpu.name === spu.name }]">
                <div>{{ spu.name }}</div>
              </div>
            </a>
          </div>
        </div> -->

        <div>
          <!--advantages-->
          <div class="summer-content h-full max-w-[1200px] mx-auto flex flex-wrap justify-between gap-x-[24px] gap-y-[8px] px-[10px]">
            <div v-for="adv in currentSpu.advantages" :key="adv" class="mt-[15px] text-[#223265]">
              <i class="el-icon-s-opportunity mr-[9px] inline-block"></i>
              <span>{{ adv }}</span>
            </div>
          </div>

          <!--skus-->
          <div class="summer-content w-full overflow-x-auto scrollbar-hide">
            <slot name="skus"></slot>
          </div>
        </div>
      </div>
    </div>

    <!--package info-->
    <div>
      <section class="w-full my-[68px]">
        <div class="w-full grid grid-cols-1 lg:grid-cols-3 gap-[24px] max-w-[1210px] mx-auto px-[10px]">
          <PackageItemView v-for="(item, index) in currentSpu.info" :key="index" :dummy="item.dummy || false" :img="getImg(item.img) || ''"
            :title="item.title || ''" :tips="item.tips || ''" :details="item.details || []" :reverse="index % 2 == 1" 
            class="fade-in"/>
        </div>
      </section>
    </div>

    <!--usecase-->
    <div class="w-full pt-[65px] pb-[55px] box-border text-white"
      style="background-image: linear-gradient(175deg, #00414a 0%, #00414a 100%);">
      <div class="w-full max-w-[1200px] mx-auto">
        <div class="text-[35px] leading-[35px] font-medium text-center">{{ $t("pricing.usecases.title") }}</div>
        <div class="mt-[55px] flex justify-between items-start flex-wrap">

          <div v-for="(uc, index) in usecases" :key="index" class="fade-in w-[340px]">
            <div class="mx-auto w-max h-[120px]"><img class="h-full" :src="getImg(uc.img)" alt="">
            </div>
            <div class="mt-[45px] text-[24px] font-medium text-center">{{ uc.title }}</div>
            <div class="w-[300px] mx-auto mt-[50px] text-[16px] font-medium">{{ uc.detail }}</div>
          </div>

        </div>
      </div>
    </div>

    <!--reviews-->
    <div class="w-full bg-[#e9ecec]">
      <div class="w-full max-w-[1200px] mx-auto pt-[65px] pb-[85px]">
        <div class="text-[35px] font-medium text-[042B84] leading-[28px] text-center">{{ $t("pricing.userReviews.title") }}</div>
        <div class="fade-in w-full mx-auto mt-[80px] flex justify-between items-center">
          <div @click="arrowClick('prev')" class="w-[36px] cursor-pointer"><img class="w-full" src="@/assets/index/img/pay/carousel_prev.png">
          </div>
          
          <el-carousel :interval="4000" type="card" arrow="never" height="170px" width="100%" indicator-position="none" ref="carouselCard">
            <el-carousel-item v-for="(review, index) in userReviews" :key="index">
              <div class="w-full h-full flex items-center justify-start shrink-0 pt-[20px] pl-[20px] box-border bg-[#fff]">
                <div class=" w-[20%] h-full flex justify-start items-center flex-col">
                    <div class="mb-10">
                        <img src="@/assets/index/img/pay/customer_avatar.png" alt="">
                    </div>
                    <div class="mt-[10px] text-[18px] font-medium text-[#276DFD] leading-none">
                        <span data-lang="buy_bottom_module_name1">{{ review.userName }}</span>
                    </div>
                </div>
                
                <div class="ml-[5%] w-[70%] h-full flex flex-col justify-start items-start">
                    <div class="customer-star">
                        <img v-for="(n, ni) in review.stars" :key="ni" class="mr-[10px] inline-block" src="@/assets/index/img/pay/customer_star.png" alt="">
                    </div>
                    <div class="mt-[15px] leading-[1.2]">
                        {{ review.review }}
                    </div>
                </div>
              </div>
            </el-carousel-item>
          </el-carousel>

          <div @click="arrowClick('next')" class="w-[36px] cursor-pointer"><img class="w-full" src="@/assets/index/img/pay/carousel_next.png">
          </div>
        </div>
      </div>
    </div>

    <slot name="dialog"></slot>
  </div>
</template>

<script>
import PackageItemView from "@/components/package-view/package-item-view.vue"
import { isPromotionEnabled } from '@/config/site-theme'

export default {
  name: 'BaseView',
  components: {
    PackageItemView,
  },

  data() {
    return {
    }
  },
  props: {
    plan: {
      type: String,
    },
    introduction: {
      type: String,
    },

    categories: {
      type: Array,
      require: true,
      readonly: true,
      default: () => {
        return [{
          name: '',
          url: '',
        }]
      }
    },
    spus: {
      type: Array,
      require: true,
      readonly: true,
      default: () => {
        return [{
          name: '',
          url: '',
        }]
      }
    },
    currentCategory: {
      type: Object,
      require: true,
      readonly: true,
      default: () => {
        return {
          name: '',
          url: '',
          advantages: [],
        }
      }
    },
    currentSpu: {
      type: Object,
      require: true,
      readonly: true,
      default: () => {
        return {
          name: '',
          url: '',
          advantages: [],
          skuList: [],
          info: [{img: '', title: '', tips: '', detail: []}]
        }
      }
    },
  },
  computed: {
    usecases() {
      return this.$t("pricing.usecases.items");
    },
    userReviews() {
      return this.$t("pricing.userReviews.items");
    },
    promotionEnabled() {
      return isPromotionEnabled();
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    getImg(img) {
      if (typeof(img) !== 'undefined') {
        return require(`@/assets/index/img/${img}`);
      }
      return null;
    },
    navigateToPlan(t, isSpu) {
      if ((isSpu && this.currentSpu.name !== t.name) || (!isSpu && this.currentCategory.name !== t.name)) {
        window.location.href = t.url;
      }
    },
    arrowClick(dir) {
      if(dir === 'next') {
          this.$refs.carouselCard.next()
      } else {
          this.$refs.carouselCard.prev()
      }
    },
    clickBuyPlan(sku, duration) {
      console.log(duration)
    },
    
    async init() {
      this.initIntersectionObserver();
    },
    async initIntersectionObserver() {
      const options = {
        threshold: 0.1
      };
      const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const element = entry.target;
            element.classList.add('fade-in-end');

            observer.unobserve(entry.target);
          }
        });
      }, options);

      this.$nextTick(() => {
        const elements = this.$el.querySelectorAll('.fade-in')
        elements.forEach(element => {
          observer.observe(element);
        });
      });
    },
  }
}
</script>

<style lang="scss" scoped>

::v-deep {
  .el-carousel {
    width: calc(100% - 100px);
    margin: 0 auto;
  }

  .el-carousel__container {
    position: relative;
  }

  .el-carousel__item {
    height: 99%;
    background-color: #fff;
    border-radius: 10px;
    box-shadow: 0px 0px 13px 0px rgba(216,219,224,0.7);
  }
}

</style>
